export default {
  '--cell-description-color': '#aaa',
  '--cell-border-color': '#545454'
};